import Tween from "tween.ts";
import Animation from "../Animation";
import Point from "../../entities/Point";


export default class DrawPointAnim extends Animation {
  private Anim = Animation.getInstance();
  private isStopped = false;

  constructor(point: Point, onComp: () => void, resolve: () => void) {
    super();
    if(!point) { return }
    if(this.Anim.getIsCancelled()) {
      point.scale.set(1);
      resolve();
      return
    };

    point.visible = true;
    point.scale = 0.2;
    
    const p = { s: point.scale };

    new Tween.Tween(p)
      .to({ s:1 }, 300)
      .easing(Tween.Easing.Elastic.Out)
      .onUpdate(p => {
        const isCancelled =  this.Anim.getIsCancelled();
        if(isCancelled) {
          this.isStopped = true;
          point.scale.set(1);
          onComp();
        }
        if(!this.isStopped) {
          point.scale.set(p.s);
        }
      })
      .onComplete(() => onComp())
      .start()
  }
}